<template>
  <div class="hello">
    <img src="../assets/Images/3.jpg"/>
     <img src="../assets/Images/1.jpg"/>
     <img :src="test"/>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data:function(){
    return {
      test:require('../assets/Images/2.jpg')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #d3e6dd;
}
img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue